<!---===================== MODAL FOR SAME FILES FIN =====================--->
<section class="Modal-Global" id="ModalSameFHFIN{{this.ModalNumber}}">
  <div class="Container-General-Duplicated" id="ModalSameFilesFIN{{this.ModalNumber}}">
    <div class="Top-Close"><a (click)="Toggle_Modal_Same_Files_FIN()" class="btn-cerrar-popup"><i
          class="fas fa-times"></i></a></div>
    <div class="Container-Duplicated">
      <div class="Header-Duplicated">
        <div class="Title">¡Importante!</div>
        <div class="Subtitle">Proceso existente con el nombre '{{FileAddSameFIN.FileName}}'</div>
      </div>
      <div class="body-Duplicated">
        <div class="Table">
          <table>
            <thead>
              <th class="on1">Ubicación</th>
              <th class="on2">Nombre</th>
            </thead>
            <tbody>
              <tr *ngFor="let file of AllFileSame">
                <td>
                  {{file.Path}}
                </td>
                <td>{{file.Name}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="Fotter-Duplicated">
        <div (click)="Toggle_Modal_Same_Files_FIN()" class="Btn-OK">
          OK
        </div>
      </div>
    </div>
  </div>
</section>
